import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { fmtDual } from "@/lib/proofPdf";

export default function Verifier() {
  const { hash } = useParams();
  const [state, setState] = useState("loading");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/proof/verify/${hash}`).then(({ data }) => {
      setData(data);
      setState(data?.valid ? "valid" : "invalid");
    }).catch(() => setState("invalid"));
  }, [hash]);

  const s = data?.summary || {};
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container page-content fade-in" data-testid="verifier-page">
        <div style={{ maxWidth: 640, margin: "0 auto", paddingTop: "4vh" }}>
          <p className="eyebrow">VÉRIFICATION / VERIFICATION</p>
          <h1 className="mb-6">Authenticité du justificatif</h1>

          {state === "loading" && <p className="muted" data-testid="verifier-loading">Vérification en cours…</p>}

          {state === "valid" && (
            <div data-testid="verifier-valid" style={{ background: "#ffffff", color: "#111", borderRadius: 14, padding: "28px 32px", boxShadow: "0 2px 20px rgba(0,0,0,0.25)" }}>
              <div style={{ fontSize: 40 }}>✅</div>
              <h2 style={{ color: "#111", margin: "8px 0 4px" }}>Justificatif authentique</h2>
              <p style={{ color: "#15803d", fontWeight: 600, margin: 0 }}>Valid proof — issued by IDEVORAI, not altered.</p>
              <div style={{ borderTop: "1px solid #eee", margin: "18px 0", paddingTop: 16, lineHeight: 1.7 }}>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>N° / Proof number:</strong> {data.doc_number || "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Client / Customer:</strong> {s.email || "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Offre / Plan:</strong> {s.plan_name || "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Montant / Amount:</strong> {s.amount != null ? `${Number(s.amount).toFixed(2)} ${s.currency || "EUR"}` : "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Paiement / Payment:</strong> {fmtDual(s.paid_date, "—")}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>ID paiement Whop / Whop payment ID:</strong> {s.whop_payment_id || "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Compte / Account:</strong> {s.whop_account || "—"}</p>
                <p style={{ margin: "4px 0", color: "#111" }}><strong>Émis le / Issued:</strong> {fmtDual(data.issued_at, "—")}</p>
              </div>
              <p style={{ margin: 0, wordBreak: "break-all", fontFamily: "monospace", fontSize: 11, color: "#666" }}>SHA-256: {data.hash}</p>
            </div>
          )}

          {state === "invalid" && (
            <div data-testid="verifier-invalid" style={{ background: "#ffffff", color: "#111", borderRadius: 14, padding: "28px 32px", boxShadow: "0 2px 20px rgba(0,0,0,0.25)" }}>
              <div style={{ fontSize: 40 }}>⚠️</div>
              <h2 style={{ color: "#111", margin: "8px 0 4px" }}>Justificatif introuvable ou modifié</h2>
              <p style={{ color: "#b91c1c", fontWeight: 600, margin: 0 }}>This proof could not be verified — unknown or altered document.</p>
              <p className="muted" style={{ color: "#666", marginTop: 12 }}>Empreinte recherchée / Fingerprint: <span style={{ fontFamily: "monospace", wordBreak: "break-all" }}>{hash}</span></p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
